import React, { FC } from "react";
import Layout from "../components/layout";
import { graphql, useStaticQuery } from "gatsby";
import { Query } from "../generated/graphql";
import { H2, H5, Paragraph } from "../components/ui/typography";
import Img, { FluidObject } from "gatsby-image";
import { Header } from "../components/ui/semanticElements/header";
import { Main } from "../components/ui/semanticElements/main";
import { Figure, Figcaption } from "../components/ui/figure";

const AboutPage: FC = () => {
  const data = useStaticQuery<Query>(graphql`
    query {
      allContentfulAbout {
        nodes {
          seoPageTitle
          seoPageDescription
          title
          intro
          competences {
            title
            description
            banner {
              title
              description
              fluid {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `);
  const { seoPageTitle, seoPageDescription, title, intro, competences } = data.allContentfulAbout.nodes[0];

  return (
    <Layout pageTitle={seoPageTitle as string} pageDescription={seoPageDescription as string}>
      <Header>
        <H2 as="h1">{title}</H2>
        <Paragraph as="h2">{intro}</Paragraph>
      </Header>
      <Main>
        {competences?.map(c => {
          if (c) {
            return (
              <Figure alternate>
                <Figcaption>
                  <H5>{c.title}</H5>
                  <Paragraph>{c.description}</Paragraph>
                </Figcaption>
                <Img
                  fluid={c.banner?.fluid as FluidObject}
                  title={c.banner?.title as string}
                  alt={c.banner?.description as string}
                />
              </Figure>
            );
          }
        })}
      </Main>
    </Layout>
  );
};

export default AboutPage;
